import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type AjaxFetchService from 'garaje/services/ajax-fetch';

interface ModelParams {
  page?: string;
  status?: string;
}

export default class HrisDashboardAdminApprovalsRoute extends Route {
  @service declare ajaxFetch: AjaxFetchService;

  controllerName = 'location-overview/hris-dashboard/admin-approvals';
  templateName = 'location-overview/hris-dashboard/admin-approvals';

  queryParams = {
    page: { refreshModel: true },
    status: { refreshModel: true },
  };

  model(params: ModelParams): Promise<unknown> {
    const qs = new URLSearchParams();
    if (params.page) qs.append('page', params.page);
    if (params.status) qs.append('status', params.status);
    return this.ajaxFetch.request(`/api/v1/hris/admin-approvals${qs.toString() ? `?${qs}` : ''}`);
  }
}
